module.exports = __webpack_public_path__ + "img/e.e56098a8.jpg";